import { render, staticRenderFns } from "./reservationQrCode.vue?vue&type=template&id=182ad224"
import script from "./reservationQrCode.vue?vue&type=script&lang=js"
export * from "./reservationQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports